module.exports = __webpack_public_path__ + "img/presentation-disabled.1c2f7a35.svg";